import { DeliveryOrderPrintPage } from "@/features/delivery-order/pages/DeliveryOrderPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order/$id/print")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["delivery_order.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: DeliveryOrderPrintPage,
});
